import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";
import FullPageLoader from "@Components/FullPageLoader";

const AuthorDesktop = loadable(() => import("./AuthorDesktop/AuthorDesktop"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <AuthorDesktop {...props} />
  </ErrorBoundary>
);
